var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tooltip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.05078C4.68629 2.05078 2 4.80528 2 8.20312C2 11.601 4.68629 14.3555 8 14.3555C11.3137 14.3555 14 11.601 14 8.20312C14 4.80528 11.3137 2.05078 8 2.05078ZM0.666667 8.20312C0.666667 4.0502 3.94991 0.683594 8 0.683594C12.0501 0.683594 15.3333 4.0502 15.3333 8.20312C15.3333 12.356 12.0501 15.7227 8 15.7227C3.94991 15.7227 0.666667 12.356 0.666667 8.20312Z",
    fill: "#07679B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.51953C8.36819 7.51953 8.66667 7.82559 8.66667 8.20312V10.9375C8.66667 11.315 8.36819 11.6211 8 11.6211C7.63181 11.6211 7.33333 11.315 7.33333 10.9375V8.20312C7.33333 7.82559 7.63181 7.51953 8 7.51953Z",
    fill: "#07679B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 5.46875C7.33333 5.09121 7.63181 4.78516 8 4.78516H8.00667C8.37486 4.78516 8.67333 5.09121 8.67333 5.46875C8.67333 5.84629 8.37486 6.15234 8.00667 6.15234H8C7.63181 6.15234 7.33333 5.84629 7.33333 5.46875Z",
    fill: "#07679B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.8fdb6902f760e33edc2fcac2a54f0c9c.svg";
export { ForwardRef as ReactComponent };